import { gql } from 'src/generated/gql';

export const PATIENT_INTERNAL_ID_QUERY = gql(`
  query PatientInternalId($zendeskExternalId: ID!) {
    staff_getPatientByZendeskExternalId(zendeskExternalId: $zendeskExternalId) {
      id
    }
  }
`);
